<template>
    <!-- 最新上架 -->
    <div>
        <div style="position: relative;">
            <img style="width:100%;height:399px;" src="icon/learnIcon/bg_red.svg" alt="">
            <div class="bg-color" :style="{background:bgColor[random] }"></div>
        </div>

        <div>
            <div class="main">
                <div class="title">最新上架</div>
                <div class="content" v-if="dataL.length > 0">
                    <div class="item-model" v-for="(item , index) in dataL.slice(0,6)" :key="index"
                         @click="toDetail(item.id)">
                        <div class="item-img ">
                            <img class="cover coverImg" :src="item.coverImg" alt="">
                            <img class="play-icon" src="icon/learnIcon/choiceness-play.svg" alt="">
                        </div>
                        <div class="introduction">
                            {{item.title}}
                        </div>
                    </div>
                </div>
                <div class="content" style="justify-content: center;align-content: center;" v-else>
                    <div>
                        该分类下暂无内容哦
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>

// part
// import shixunPagePart from '@/components/shixunApp/shixunPagePart';

//
import requestManager from '@comp/platformApi/requestManager';

import consoleHelper from '@util/consoleHelper';

// const config = {
//     apiConfig : {
//         list : {
//             url : 'portal/api/audio',
//             params:{
//                 categoryFirst:'',
//                 categorySecond:'',
//                 title:'',
//                 type:'',

//             },
//             dataPath : 'data.records',
//             totalPath : 'data.total',
//             totalPagePath : 'data.pages'
//         }
//     }
// };

export default {
    name: "newReleases",
    // extends : shixunPagePart,
    props: ['random', 'classifyItem'],
    watch: {
        classifyItem: {
            handler(newItem, oldItem) {
                this.getData1();
            },
            deep: true
        },
    },
    data() {
        return {
            //  enableDataList : true,
            // autoLoadDataList : true,
            // scrollToLoadNextPage:false,
            // apiConfig : config.apiConfig,

            getData: {},
            qData: {},
            dataL: [],
            bgColor: ['linear-gradient(to bottom, #FF9295 0%,#ffffff 100%)',
                'linear-gradient(to bottom, #FFD381 0%,#ffffff 100%)',
                'linear-gradient(to bottom, #BDE6FF 0%,#ffffff 100%)',],

        }
    },

    methods: {
        toDetail(id) {
            this.$router.push({name: 'albumID', params: {id: id}})
        },

        getData1() {
            if (this.classifyItem) {
                let item = this.classifyItem
                let qData = {}
                qData.categoryFirst = item.id
                // qData.categorySecond = item.pid
                // qData.title = item.name
                qData.type = 0
                if (qData.categoryFirst) {

                    requestManager.request({
                        url: 'portal/api/audio',
                        params: qData || {}
                    }, (error, result) => {
                        if (error)
                        {
                            consoleHelper.logError('load latest keyword list fail: ' + error.msg);
                            return;
                        }

                        this.dataL = result.data.records || [];
                    })
                }

            }
        }

    },
    mounted() {
        this.getData1();
    }
}
</script>
<style lang="scss" scoped>
.bg-color {
    position: absolute;
    top: 0;
    width: 100%;
    height: 399px;
    border-radius: 20px;

    opacity: .7
}


.main {
    position: absolute;
    top: 130px;
    left: 5%;
    width: 90%;
    height: 100%;
    margin: 0 auto;
}

.title {
    padding-top: 15px;
    padding-bottom: 20px;
    font-size: 18px;

    font-weight: 600;
    color: #FFFFFF;

}

.content {
    width: 100%;
    height: 304px;
    display: flex;
    flex-wrap: wrap;


    justify-content: space-between;
    align-content: space-between;
    .item-model {
        width: 102px;
        height: 143px;
        .item-img {
            position: relative;
            width: 102px;
            height: 102px;
            border-radius: 11px;
            margin-bottom: 8px;
            .coverImg {
                width: 100%;
                height: 100%;
                border-radius: 11px;
            }
            .play-icon {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 26px;
                height: 26px;
            }
        }
        .introduction {
            width: 100%;

            font-size: 12px;

            font-weight: 400;
            color: #2E303A;


        }

    }

}

</style>
